module.exports = __webpack_public_path__ + "8215d3b43baf4fa5fe7af4043f18aea3.jpg";